import graphql from "babel-plugin-relay/macro";

const AcceptanceReportPageCsvQuery = graphql`
  query AcceptanceReportPageCsvQuery {
    blocSystemDocumentTemplatesAcceptanceCsv {
      taskId
    }
  }
`;

export default AcceptanceReportPageCsvQuery;
